import { CreatePoolComposite } from "@/domains/thick-v2/components/create-pool/create-pool-composite"

/**
 * Create Manual CL Pool Page
 * 
 * Rebuilt using DDD architecture:
 * - All state managed in CreatePoolStore (MobX)
 * - All data fetching through orchestrators
 * - View/Composite component separation
 * - No hooks for business logic
 * - Automatic price calculation (Uniswap v3 pattern)
 * - Shows all possible pools (existing + new) like Aerodrome
 */
export default function CreateManualClPoolPage() {
  return <CreatePoolComposite />
}
